export default __webpack_public_path__ + "static/media/exchange-history-white.ae31a98a.svg";